import { createContext } from 'react'
import { BrightCovePlayer } from './BrightCovePlayer'

export interface PlayerContextData {
  player?: BrightCovePlayer
  isPlaying?: boolean
  isFullscreen?: boolean
}

export const VideoPlayerContext = createContext<PlayerContextData>({})
